import { RootState } from '../../../common/store/store';
import { BrandValuesInterface } from './brandValues.state';

export const selectBrandValues = (state: RootState): BrandValuesInterface | undefined =>
  state.review.brandValues.contentBrandValues;
